import * as z from "zod";
import { isUniqueConstraintViolation } from "../dbErrors";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

export const authorizeOAuthAppForServiceAccountSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  serviceAccountId: z.string(),
});

// Tier-2 authorization: lets a registered OAuth app obtain credentials acting
// as this service account. Gated on service_account:manage (the per-account
// admin right), mirroring createServiceAccountFederation: it grants the account
// no new authority, it only lets the app assume it. The app itself is
// registered separately by a tenant admin (tenant:oauth_apps_manage); a manager
// can only pick from already-registered apps.
export const authorizeOAuthAppForServiceAccount = mutator({
  schema: authorizeOAuthAppForServiceAccountSchema,
  resolve: {
    serviceAccount: { kind: "serviceAccount", from: "serviceAccountId" },
    app: { kind: "oauthClient", from: "clientId" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.serviceAccount.id,
    },
  ],
  fn: async ({ tx, ctx, args: { id, serviceAccount, app } }) => {
    const now = Date.now();
    try {
      await tx.mutate.oauthClientServiceAccount.insert({
        id,
        clientId: app.id,
        serviceAccountId: serviceAccount.id,
        createdByUserId: ctx.userId,
        createdAt: now,
        tenantId: ctx.tenantId,
      });
    } catch (err) {
      if (
        isUniqueConstraintViolation(err, "oauth_client_service_account_unique")
      ) {
        throw userFacingError(
          "This app is already authorized for this account"
        );
      }
      throw err;
    }
  },
});
